import React, { useMemo, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactIconsCombo } from "utils/ReactIconsCombo";
import { FixedSizeList as List } from "react-window";
import Select from "react-select";
const BasicInformation = () => {
  const {
    register,
    clearErrors,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  const customStylesForIcon = {
    control: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      // borderColor: errors.icons ? "red" : provided.borderColor,
      borderColor: errors.icon ? "red" : "#dbdbdb",
      "&:hover": {
        borderColor: errors.icon ? "red" : provided["&:hover"].borderColor,
      },
    }),
    input: (provided) => ({
      ...provided,
      color: "black",
      paddingTop: "4px",
      paddingBottom: "4px",
    }),
  };

  const MenuList = (props) => {
    const { options, children, maxHeight, getValue } = props;
    const height = 35; // Height for each row
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * height;

    return (
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={height}
        initialScrollOffset={initialOffset}
        width="100%"
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  };


  const iconNames = Object.keys(ReactIconsCombo);
  const [inputValue, setInputValue] = useState("");
  const filteredIcons = useMemo(
    () =>
      iconNames
        .filter((iconName) =>
          iconName.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((iconName) => ({
          value: iconName,
          label: (
            <div className="flex items-center gap-2">
              {React.createElement(ReactIconsCombo[iconName])} {iconName}
            </div>
          ),
        })),
    [inputValue]
  );

  const handleInputFocus = () => {
    clearErrors(`logo`);
  };

  const SOCIAL_PLATFORMS = ["Facebook", "Instagram", "Twitter", "Linkedin", "Youtube", "Tiktok"

  ];


  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Select
                  className="py-2"
                  isInvalid={!!errors.name}
                  {...register("name", {
                    required: "Social platform is required",
                  })}
                >
                  <option value="">Select Social Platform</option>

                  {SOCIAL_PLATFORMS.map((p) => (
                    <option key={p} value={p}>
                      {p}
                    </option>
                  ))}
                </Form.Select>

                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.name?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>


            <Col md="6">
              <Form.Group controlId="logo">
                <div title="Select an icon">
                  <Select
                    name="logo"
                    styles={customStylesForIcon}
                    options={filteredIcons}
                    components={{ MenuList }}
                    isClearable
                    onFocus={handleInputFocus}
                    placeholder="Select an icon"
                    onChange={(selectedOption) => {
                      // console.log("Selected icon:", selectedOption);
                      setValue(
                        "logo",
                        selectedOption ? selectedOption.value : ""
                      );
                    }}
                    value={filteredIcons.find(
                      (option) => option.value === watch("logo")
                    )}
                    className={`basic-single ${errors.logo ? "is-invalid" : ""
                      }`}
                  />
                </div>

                {errors.logo && (
                  <Form.Control.Feedback type="invalid">
                    {errors.logo.message}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>


            <Col md="6" style={{ paddingRight: "4px" }}>
              <Form.Check
                type="checkbox"
                id="defaultSwitch"
                label="Active"
                className="mt-2 "
                defaultChecked={!state}
                isInvalid={!!errors.status}
                {...register("status")}
              />
            </Col>


          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
